import React from 'react';
import PropTypes from 'prop-types';

import { SearchIcon14 } from '../RacingThemeSearch/RacingThemeSearchIcons';
import styles from './RacingThemeSearchBannerButton.module.css';

/**
 * Search banner submit button.
 */
const RacingThemeSearchBannerButton = props => {
  const { onClick } = props;

  return (
    <button type="button" className={styles.searchBtn} onClick={onClick}>
      <SearchIcon14 />
      Search
    </button>
  );
};

RacingThemeSearchBannerButton.propTypes = {
  onClick: PropTypes.func,
};

export default RacingThemeSearchBannerButton;
